"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusStickerWidget = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var StatusIcons_1 = require("../../icons/StatusIcons");
var StickerWidget_1 = require("./StickerWidget");
var StickerIconSize = 14;
var StatusStickerColorMap = {
    error: 'red',
    warning: 'yellow',
    info: 'blue',
    success: 'green',
};
/** Status Stickers have built-in icons and styling, reserved for their respective uses. */
var StatusStickerWidget = function (props) {
    return React.createElement(StickerWidget_1.StickerWidget, tslib_1.__assign({}, props, { icon: React.createElement(StatusIcons_1.StatusIcon, { type: props.stickerType, size: StickerIconSize }), stickerType: StatusStickerColorMap[props.stickerType] }));
};
exports.StatusStickerWidget = StatusStickerWidget;
exports.StatusStickerWidget.displayName = 'StatusStickerWidget';
//# sourceMappingURL=StatusStickerWidget.js.map